module.exports = __webpack_public_path__ + "media/images/logo-fa592b58208a7d24332331016f72a2d3.png";